import { useState, useCallback } from 'react';

const LS_KEY = 'gamedrop_wishlist_v1';

function load() {
  try {
    return new Set(JSON.parse(localStorage.getItem(LS_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

function save(set) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify([...set]));
  } catch { /* storage full */ }
}

export function useWishlist() {
  const [wishlist, setWishlist] = useState(load);

  const toggleWishlist = useCallback((game) => {
    setWishlist(prev => {
      const next = new Set(prev);
      if (next.has(game.id)) {
        next.delete(game.id);
      } else {
        next.add(game.id);
      }
      save(next);
      return next;
    });
  }, []);

  const isWishlisted = useCallback((id) => wishlist.has(id), [wishlist]);
  const wishlistSize = wishlist.size;

  return { isWishlisted, toggleWishlist, wishlistSize };
}
